import { RouteSelector } from './RouteSelector'
import { useDisruptionsTableFormStateStore } from '@/pages/Disruptions/store'
import { UseFormReturn } from 'react-hook-form'
import { DisruptionFormValues } from '@/pages/Disruptions/types'
import { Input } from '@/ui/Input'
import styles from './RouteSelector.module.scss'
import { KeyboardEvent, useRef } from 'react'

export const RouteSelectorContainer = ({
    form,
    areaRoutes,
}: {
    form: UseFormReturn<DisruptionFormValues>
    areaRoutes: string[]
}) => {
    const { selectedRoutes, setSelectedRoutes } = useDisruptionsTableFormStateStore()
    const ref = useRef(false)

    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Tab') {
            e.preventDefault()
            form.setFocus('location')
            form.setValue('routes', selectedRoutes.join(', '))
        }
    }

    return (
        <div onKeyDown={handleKeyDown}>
            <RouteSelector
                availableRoutes={areaRoutes}
                selectedRoutes={selectedRoutes}
                onChange={(routes) => {
                    setSelectedRoutes(routes)
                }}
                searchValue={form.watch('routes') ?? ''}
                triggerComponent={
                    <Input
                        {...form.register('routes')}
                        onBlur={(e) => {
                            const relatedTarget = e.relatedTarget as HTMLElement | null
                            const isClickOutsideExcluded = relatedTarget?.closest('[data-click-outside-exclude]')

                            if (isClickOutsideExcluded) {
                                ref.current = true
                                e.target.focus()
                            }

                            if (!isClickOutsideExcluded) {
                                form.setValue('routes', selectedRoutes.join(', '), { shouldDirty: true })
                                ref.current = false
                            }
                        }}
                        variant="table"
                        type="text"
                        transparent
                        fullWidth
                        placeholder={'Routes'}
                        className={styles.routesInput}
                        onFocus={() => {
                            if (ref.current) {
                                ref.current = false
                                return
                            }
                            form.setValue('routes', '')
                        }}
                    />
                }
            />
        </div>
    )
}
